"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ReactHTMLPicture = _interopRequireDefault(require("@micado-digital/react-htmlpicture/ReactHTMLPicture"));

var _Item = _interopRequireDefault(require("./Item.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Item = function Item(_ref) {
  var absoluteMediaURLs = _ref.absoluteMediaURLs,
      media = _ref.media,
      mediaFormats = _ref.mediaFormats,
      resourceURL = _ref.resourceURL,
      text = _ref.text,
      title = _ref.title,
      webpFallback = _ref.webpFallback;
  var REACT_APP_PATH = process.env.REACT_APP_PATH;
  var css = (0, _Item.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-gallery-05__item", css.item)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-gallery-05__item-image", css.image)
  }, /*#__PURE__*/_react.default.createElement(_ReactHTMLPicture.default, {
    className: css.image,
    lazy: false,
    media: media,
    path: !absoluteMediaURLs ? resourceURL !== null && resourceURL !== void 0 ? resourceURL : REACT_APP_PATH : "",
    mediaFormats: _objectSpread({}, mediaFormats),
    webpFallback: webpFallback
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-gallery-05__item-content", css.content)
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: "mco-gallery-05__item-title",
    dangerouslySetInnerHTML: {
      __html: title
    },
    component: "p",
    variant: "h4"
  }), text && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)("mco-gallery-05__item-text", css.text),
    dangerouslySetInnerHTML: {
      __html: text
    },
    component: "p",
    variant: "body2"
  })));
};

Item.propTypes = {
  absoluteMediaURLs: _propTypes.default.bool,
  id: _propTypes.default.number,
  data: _propTypes.default.object,
  mediaFormats: _propTypes.default.object,
  resourceURL: _propTypes.default.string,
  webpFallback: _propTypes.default.bool
};
var _default = Item;
exports.default = _default;